/* Publish by EComposer at 2026-10-09 04:12:03*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fdmrc0ezrui"]=  window.__ectimmers["ecom-fdmrc0ezrui"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-fdmrc0ezrui').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fdmrc0ezrui', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lowbjpujtp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lowbjpujtp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8mq8icwuagm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8mq8icwuagm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4y19yg14htv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4y19yg14htv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-14e730zj2ajl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-14e730zj2ajl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-euftglaz7z7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-euftglaz7z7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ugfkgq8mc9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ugfkgq8mc9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-izwvuy5imbd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-izwvuy5imbd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wctbpyj9e7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wctbpyj9e7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-08fk3ak9wqmn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-08fk3ak9wqmn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3kekvjd9c7y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3kekvjd9c7y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmg2ccyd4zp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmg2ccyd4zp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-am8wmjkrhrq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-am8wmjkrhrq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aibz8qiqh2q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aibz8qiqh2q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8lsu2as07qm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8lsu2as07qm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o71hder6uv9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o71hder6uv9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z5ppnivog3j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z5ppnivog3j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r8xtazy7thn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r8xtazy7thn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ruoq6pr8s7b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ruoq6pr8s7b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wa6dnorqmmo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wa6dnorqmmo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u4rkyz850dq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u4rkyz850dq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k0zuxts1w8c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k0zuxts1w8c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ivz1bsipl2h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ivz1bsipl2h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9lv2b0tmk1i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9lv2b0tmk1i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lvkgryd3lde').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lvkgryd3lde', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nhsm1848j1k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nhsm1848j1k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4br27zr46rt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4br27zr46rt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d3vsp2gp7cm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d3vsp2gp7cm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aako40muc2l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aako40muc2l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w0hvbkk4hab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w0hvbkk4hab', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xteks9vw4zg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xteks9vw4zg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8naem2z8fwk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8naem2z8fwk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uyaqtazz4y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uyaqtazz4y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k6c37zqg36').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k6c37zqg36', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-antlr9ewoyw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-antlr9ewoyw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i6qbugddtk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i6qbugddtk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-spob0xuuq3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-spob0xuuq3l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vvrqrz0hgo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vvrqrz0hgo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q6l51ndrlbe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q6l51ndrlbe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t4mjzfmxv5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t4mjzfmxv5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t6ojmuzd3x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t6ojmuzd3x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0cmn0wnnzlvh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0cmn0wnnzlvh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0bg0yya90m7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0bg0yya90m7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ist2wauonq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ist2wauonq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dtdt89xz0dm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dtdt89xz0dm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1idhhaibuqm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1idhhaibuqm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wwb036cqoy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wwb036cqoy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p63kshiy7q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p63kshiy7q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0cdld9qkscnp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0cdld9qkscnp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o5v1oj4w7kb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o5v1oj4w7kb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hic2ew96mzj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hic2ew96mzj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i06scd4jn3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i06scd4jn3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i68ibqapkua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i68ibqapkua', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5y761ditpjf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5y761ditpjf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-acwi2inriag').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-acwi2inriag', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k6uljw9spn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k6uljw9spn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-50abyu6g7x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-50abyu6g7x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ec407wvxvi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ec407wvxvi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c75gn6hcobq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c75gn6hcobq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-938psbi2uck').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-938psbi2uck', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zn92ksec3j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zn92ksec3j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p1dhy8vn0f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p1dhy8vn0f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t48e5lthqdk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t48e5lthqdk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-43x96u7lzsg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-43x96u7lzsg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tmq9r2ni2nc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tmq9r2ni2nc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nqbbn3hrbuf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nqbbn3hrbuf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ds1ewvfpa8c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ds1ewvfpa8c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8kcer1p3eng').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8kcer1p3eng', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-swkjus5zwg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-swkjus5zwg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9p95pamvplc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9p95pamvplc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d5qhv0bfnj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d5qhv0bfnj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tl06maj12v8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tl06maj12v8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4jdkccxlf6w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4jdkccxlf6w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8fpkgm6zngv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8fpkgm6zngv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9c7yhhml2o8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9c7yhhml2o8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ug78twkgi1d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ug78twkgi1d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-75px85ajg85').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-75px85ajg85', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xwc73a5ic5k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xwc73a5ic5k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jnmoysl4h9s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jnmoysl4h9s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vt79q4zbgta').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vt79q4zbgta', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8gee9g5gkjy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8gee9g5gkjy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1eletarnfwc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1eletarnfwc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yqizdocctjd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yqizdocctjd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ri5sxadzt5n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ri5sxadzt5n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i8rbhj73cl8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i8rbhj73cl8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rrrii1e0mu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rrrii1e0mu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p3o05j8bfy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p3o05j8bfy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jiocdiektm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jiocdiektm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vwbxjxbfyg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vwbxjxbfyg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v2nkg9i37ep').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v2nkg9i37ep', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-se5vfecp4hb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-se5vfecp4hb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d7u3tc0g65l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d7u3tc0g65l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ar5fqpuefcc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ar5fqpuefcc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k96e5q672gn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k96e5q672gn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2s99ww5f327').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2s99ww5f327', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pcsigp93p2n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pcsigp93p2n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uak1lg34x9j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uak1lg34x9j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-trnefvummuj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-trnefvummuj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vw24lv7ozyg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vw24lv7ozyg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vv67fkwvnyp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vv67fkwvnyp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ki7h509cdvc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ki7h509cdvc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-inxfgisolvc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-inxfgisolvc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lalljm7zuu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lalljm7zuu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7z70lcb8w3c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7z70lcb8w3c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nsyzbiaypr8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nsyzbiaypr8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w63vr30l1u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w63vr30l1u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o07ku72alpq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o07ku72alpq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wcstetlthje').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wcstetlthje', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2aab6izogdr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2aab6izogdr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m2c6dewbv8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m2c6dewbv8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l0fhpske33b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l0fhpske33b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pg57y4rhbbf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pg57y4rhbbf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x29endl1h6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x29endl1h6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d5wfy4w1fo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d5wfy4w1fo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3jfew84re3s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3jfew84re3s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zja1d6o53dd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zja1d6o53dd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-br3dt33v8s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-br3dt33v8s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tfkgdowbhcd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tfkgdowbhcd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hzkx044btk5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hzkx044btk5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wa485rb7wh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wa485rb7wh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rao8sn2b4nn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rao8sn2b4nn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hp57i568uv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hp57i568uv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g8n34j8kqzl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g8n34j8kqzl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o9dax946qk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o9dax946qk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h9ndcnq56pb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h9ndcnq56pb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ggzw53lwmc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ggzw53lwmc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2nhc8eh2ohm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2nhc8eh2ohm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c9joq2iouxn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c9joq2iouxn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v2g1q0ziiv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v2g1q0ziiv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sdzu0x74uup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sdzu0x74uup', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7lex7jfedum').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7lex7jfedum', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-its80136yta').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-its80136yta', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4kvm8twsjfr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4kvm8twsjfr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7luke08cgwq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7luke08cgwq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vz0j5f2xe7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vz0j5f2xe7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ynh2dmbf45').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ynh2dmbf45', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pvpwkfuex3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pvpwkfuex3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m47dqe1zwih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m47dqe1zwih', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6lwypl6sc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6lwypl6sc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x53gz1eflrd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x53gz1eflrd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zg87awr5irm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zg87awr5irm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e0mt2golj96').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e0mt2golj96', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q4b16juvb9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q4b16juvb9r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o6o5xn2hggf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o6o5xn2hggf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3l3bgkul7p4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3l3bgkul7p4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-659xgm5898c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-659xgm5898c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-43uqdzfgezk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-43uqdzfgezk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-msqzp6rcim').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-msqzp6rcim', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yfbizcwob1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yfbizcwob1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hvok9fj1q7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hvok9fj1q7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gv62ctw79oc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gv62ctw79oc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9flq3optuee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9flq3optuee', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-47m6r7eag5k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-47m6r7eag5k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sd74y9ih5uk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sd74y9ih5uk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bzkgqyyqxvi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bzkgqyyqxvi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qo6mwoe07z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qo6mwoe07z', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x6zeqtlwny').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x6zeqtlwny', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3r8sy6iqbww').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3r8sy6iqbww', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zjipx2f2vki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zjipx2f2vki', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8zj65vdcoe3"]=  window.__ectimmers["ecom-8zj65vdcoe3"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-8zj65vdcoe3"]["a99vfo4ah"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-8zj65vdcoe3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8zj65vdcoe3', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dpxx7rpwujs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dpxx7rpwujs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6we9dl67tvs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6we9dl67tvs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-59cgc314s3d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-59cgc314s3d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y0glnqtcx8b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y0glnqtcx8b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0t8j3pgc34w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0t8j3pgc34w', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1wmjoldjab4g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1wmjoldjab4g', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-e4juswzfubq"]=  window.__ectimmers["ecom-e4juswzfubq"] || {};
var C,L,A,I,j,E;let t=this.$el;if(!t)return;let e=this.isLive;const i=(C=this.settings.disable_auto_close)!=null?C:!1,o=(L=this.settings.disable_auto_close__tablet)!=null?L:!1,n=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(E=this.settings.close_all)!=null?E:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(T=>T.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(T){const R=T.getBoundingClientRect();return R.top>=0&&R.left>=0&&R.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&R.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function f(T){return n&&T<768||o&&T>767&&T<1025||i&&T>1024}function b(T){if(!T)return;const R=T.style.transition;T.style.transition="none",T.style.height="auto";const B=T.scrollHeight;T.style.height="0px",T.offsetHeight,T.style.transition=R,requestAnimationFrame(()=>{const q=r?"auto":e?B+"px":"auto";T.style.height=q})}function y(T){T.classList.remove("ecom-item-active");const R=T.querySelector(":scope > .ecom-accordion__body");R&&(r||(R.style.height=R.scrollHeight+"px",R.offsetHeight),requestAnimationFrame(()=>{R.style.height="0px"}))}function v(T){let R=0;if(T.offsetParent)do R+=T.offsetTop;while(T=T.offsetParent);return R}function w(T){const R=Math.max(0,T),B=window.pageYOffset||document.documentElement.scrollTop,q=R-B;if(q===0)return;const Z=300;let J=null;function W(oe){J||(J=oe);const se=Math.min((oe-J)/Z,1),Y=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+q*Y),se<1&&window.requestAnimationFrame(W)}window.requestAnimationFrame(W)}function k(T){w(v(T)-100)}function $(T,R=!1){T.forEach((B,q)=>{const Z=B.parentNode,J=Z.querySelector(":scope > .ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion");const W=Z.classList.contains("ecom-item-active");J&&!a&&(R&&q===0||W)&&requestAnimationFrame(()=>{J.style.height=J.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),Y=this.parentNode,ue=Y.parentNode,ge=ue.querySelectorAll(":scope > .ecom-accordion__item"),de=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),ee=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const U=this.classList.contains("ecom-item-active"),V=f(se);if(U)V?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ge.forEach(y),de.forEach(fe=>fe.classList.remove("ecom-item-active")));else{V||(ge.forEach(y),de.forEach(Ee=>Ee.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let fe=Y.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&ee&&ee.classList.add("ecom-effect-accodion"),b(ee)}window.dispatchEvent(new window.Event("renderScroll"));const K=this,ce=s||se>1024;function X(){window.dispatchEvent(new window.Event("renderScroll")),ce&&!m(K)&&k(K)}if(ce&&!r){let fe;const Ee=function(Ce){Ce.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{ue.removeEventListener("transitionend",Ee),X()},50))};ue.addEventListener("transitionend",Ee),setTimeout(()=>{ue.removeEventListener("transitionend",Ee),X()},600)}else requestAnimationFrame(()=>{setTimeout(X,100)})}})}$(d,!0),a||requestAnimationFrame(()=>{const T=t.querySelector(".ecom-item-group-init");T&&T.classList.remove("ecom-item-group-init")});function z(){const T=window.location.hash;if(T){const R=t.querySelector(`[data-target="${T}"]`);if(R){R.click(),R.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=R.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>$(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-e4juswzfubq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e4juswzfubq', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ke44nbjp87e"]=  window.__ectimmers["ecom-ke44nbjp87e"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-ke44nbjp87e"]["3yd15t9hu"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-ke44nbjp87e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ke44nbjp87e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mplrf48852b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mplrf48852b', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cwsq3kvylrf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cwsq3kvylrf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mq3mrf5erbj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mq3mrf5erbj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bgs2iolf969').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bgs2iolf969', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y2sdj2cqgo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y2sdj2cqgo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bp036t3t2qu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bp036t3t2qu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w2vjjdv9i4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w2vjjdv9i4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fygzglk4v3a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fygzglk4v3a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-reg4j8joiki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-reg4j8joiki', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lbmsw9am3b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lbmsw9am3b', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-grer9y59ovo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-grer9y59ovo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-587pqro9lga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-587pqro9lga', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-avdz3tx3qur').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-avdz3tx3qur', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mnelrwphtpo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mnelrwphtpo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-24r9gyh8603').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-24r9gyh8603', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xva3v0jh8v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xva3v0jh8v', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o7cj4fgfjs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o7cj4fgfjs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ey3uvoj4tx6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ey3uvoj4tx6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j0cgips1lj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j0cgips1lj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zm1h3g85mwk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zm1h3g85mwk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-szi1kr5nif').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-szi1kr5nif', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tl4frsu2hg9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tl4frsu2hg9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eyjwosm9a5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eyjwosm9a5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zx5hgpz28k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zx5hgpz28k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ymomwdtv09').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ymomwdtv09', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rv1ln28dbz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rv1ln28dbz', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4a47psisdw3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4a47psisdw3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h4oclxnxl69').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h4oclxnxl69', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2yq3kvxhcor').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2yq3kvxhcor', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yx5jutnj8hg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yx5jutnj8hg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v4vvujm22gs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v4vvujm22gs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qrjtuuc00v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qrjtuuc00v', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ui4qidmp18o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ui4qidmp18o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uam7psac1m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uam7psac1m', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lywpv62w8ua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lywpv62w8ua', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xpyrhdvf7uf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xpyrhdvf7uf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ejx0omo8k38').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ejx0omo8k38', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u7pk7n3zfp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u7pk7n3zfp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e3rdqemqbj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e3rdqemqbj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ngr1ud9nacg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ngr1ud9nacg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qd70ksf30l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qd70ksf30l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rxyc4xwrdd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rxyc4xwrdd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-opv7q980utj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-opv7q980utj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9qw7reldwps').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9qw7reldwps', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pfl96rglstk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pfl96rglstk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kpgzb3pp2s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kpgzb3pp2s', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ay0leaj28d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ay0leaj28d', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-avy31n9uzr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-avy31n9uzr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yriiwy0jvqi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yriiwy0jvqi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a3gnixbaak8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a3gnixbaak8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pm5d129q25s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pm5d129q25s', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n7z65vklhye').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n7z65vklhye', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rvrcxiveur').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rvrcxiveur', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-imdwtivx1xs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-imdwtivx1xs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-eoib49uzfx6"]=  window.__ectimmers["ecom-eoib49uzfx6"] || {};
if(!this.$el)return;let t=this.$el;this.isLive;var e=this.id;const i=function(){const s=document.querySelectorAll(".ecom-container-lightbox-"+e);s.length&&s.forEach(function(r){const a=r.querySelector("iframe");a!=null&&(a.contentWindow.postMessage('{"method":"pause"}',"*"),a.src="");const l=r.querySelector("video");l!=null&&l.pause()})},o=function(s){if(window.EComModal)return s();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&s()});return}let r=0;const a= window.__ectimmers["ecom-eoib49uzfx6"]["4xfl5td3k"] = setInterval(function(){window.EComModal?(clearInterval(a),s()):++r>=300&&clearInterval(a)},50)},n=this.id;t&&o(function(){var s=t.querySelector("[ecom-modal]");new window.EComModal(s,{cssClass:["ecom-container-lightbox-"+n,"ecom-html","ecom-modal","ecommodal-slide"],onOpen:function(){const r=document.querySelectorAll(".ecom-container-lightbox-"+e);r.length&&(r.forEach(function(a){const l=a.querySelector("iframe");if(l!=null){const d=l.src.replace("muted=1","muted=0").replace("mute=1","mute=0");l.src=d}const c=a.querySelector("video");c!=null&&c.play()}),window.dispatchEvent(new CustomEvent("ecom-lightbox-opened",{detail:{id:e,el:r}})))},onClose:i})}),i()

                    });
                    
                        document.querySelectorAll('.ecom-eoib49uzfx6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eoib49uzfx6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aytmrbmx1wv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aytmrbmx1wv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gvrb009okq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gvrb009okq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vpfwpni5q7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vpfwpni5q7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jaa4lrho7yf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jaa4lrho7yf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-myltbmc2c3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-myltbmc2c3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ffo4pw7sdee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ffo4pw7sdee', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bdjr7srpdms').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bdjr7srpdms', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-56h9jdh0vn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-56h9jdh0vn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c63ptaqz8ep').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c63ptaqz8ep', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kwv49g06djb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kwv49g06djb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3q869djgtyv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3q869djgtyv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pmcll1n7j1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pmcll1n7j1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qq8261wnk4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qq8261wnk4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-glln4a6dix4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-glln4a6dix4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a4e2beyx6qk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a4e2beyx6qk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7pzkesgs9p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7pzkesgs9p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-91itj0e9hv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-91itj0e9hv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sbd3kimfdcs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sbd3kimfdcs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dvaakqgpfgq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dvaakqgpfgq', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3jitw69sg8u"]=  window.__ectimmers["ecom-3jitw69sg8u"] || {};
var B,q,Z,J,W,oe,se,Y,ue,ge,de,ee,U;var t=this.$el&&this.$el.querySelector(".ecom-swiper-autoplay-toggle");if(t&&!t.getAttribute("data-ecom-bound")){t.setAttribute("data-ecom-bound","1");var e=this.$el.querySelector(".ecom-swiper-container");t.addEventListener("click",function(){var V=e&&e.swiper;!V||!V.autoplay||(V.autoplay.running?(V.autoplay.stop(),t.setAttribute("data-state","paused"),t.setAttribute("aria-label",t.getAttribute("data-label-play"))):(V.autoplay.start(),t.setAttribute("data-state","playing"),t.setAttribute("aria-label",t.getAttribute("data-label-pause"))))})}const i=this.$el;if(!i)return;const o=i.querySelector(".ecom-autoplay-progress svg"),n=i.querySelector(".ecom-autoplay-progress span"),s=(B=this.settings.disable_lazy)!=null?B:!1,r=window.EComposer&&typeof window.EComposer.normalizeSwiperSettings=="function"?window.EComposer.normalizeSwiperSettings(this.settings):this.settings,a=r.slider_loop,l=r.slider_center,c=(q=r.slider_center__tablet)!=null?q:r.slider_center,d=(J=(Z=r.slider_center__mobile)!=null?Z:r.slider_center__tablet)!=null?J:r.slider_center,m=r.slider_group,g=r.slider_items,f=(W=r.slider_group__tablet)!=null?W:r.slider_group,b=(oe=r.slider_items__tablet)!=null?oe:r.slider_items,y=(Y=(se=r.slider_group__mobile)!=null?se:r.slider_group__tablet)!=null?Y:r.slider_group,v=(ge=(ue=r.slider_items__mobile)!=null?ue:r.slider_items__tablet)!=null?ge:r.slider_items,w=r.slider_speed,k=(de=r.slider_speed__tablet)!=null?de:r.slider_speed,$=(ee=r.slider_speed__mobile)!=null?ee:r.slider_speed,z=function(V){if(window.EComSwiper)return V();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("slider_js").then(function(){window.EComSwiper&&V()});return}let K=0;const ce= window.__ectimmers["ecom-3jitw69sg8u"]["z8u5xtveu"] = setInterval(function(){window.EComSwiper?(clearInterval(ce),V()):++K>=300&&clearInterval(ce)},50)},C=function(V){return window.EComposer&&typeof window.EComposer.buildSwiperConfig=="function"?window.EComposer.buildSwiperConfig(V):null},L=function(V,K={},ce=""){return ce=="loop"?(V.items&&(window.innerWidth>1024&&V.items.length<m+g||window.innerWidth<=1024&&window.innerWidth>768&&V.items.length<f+b||V.items.length<y+v)&&(K.loop=!1),K):(window.innerWidth<=1024&&window.innerWidth>768&&V[1]?K[`${ce}`]=V[1]:window.innerWidth<768&&V[2]?K[`${ce}`]=V[2]:V[0]&&(K[`${ce}`]=V[0]),K)};let A={};o&&n&&(A={autoplayTimeLeft(V,K,ce){o.style.setProperty("--progress",1-ce),n.textContent=`${Math.ceil(K/1e3)}s`}});const I=i.querySelector(".ecom-swiper-container"),j=(U=r.disable_touch_move)!=null?U:!0;if(!I)return;const E=this,T=function(V){const K=i.querySelector(`.ecom-swiper-pagination[data-ecnav-id="${E.id}"]`),ce=i.querySelector(`.ecom-swiper-button-next[data-ecnav-id="${E.id}"]`),X=i.querySelector(`.ecom-swiper-button-prev[data-ecnav-id="${E.id}"]`);V.pagination.el=K,V.navigation.nextEl=ce,V.navigation.prevEl=X,V.pagination.renderBullet=(me,fe)=>`<span class="${fe}">
                          ${r.items&&r.items[me]&&r.items[me].slider_pagination_image?`<img src="${r.items[me].slider_pagination_image}">`:""}</span>`,A.init=function(){this.el.parentNode.classList.add("ecom-swiper-initialized-wrapper")};const le={allowTouchMove:E.isLive&&j,on:A};V.watchSlidesProgress=!0,z(function(){let me=null;function fe(){a&&(V.loop=!0,V=L(r,V,"loop")),V.centeredSlides=!1,V=L([l,c,d],V,"centeredSlides"),V=L([w,k,$],V,"speed"),me=new window.EComSwiper(I,Object.assign(V,le)),V.autoplay.enabled&&(me.on("touchStart",function(ve,Pe){ve.params.speed=300,ve.autoplay.stop()}),me.on("touchEnd",function(ve,Pe){window.innerWidth>1024&&w&&(ve.params.speed=w),window.innerWidth<=1024&&window.innerWidth>768&&k?ve.params.speed=k:w&&(ve.params.speed=w),window.innerWidth<768&&$?ve.params.speed=$:k?ve.params.speed=k:w&&(ve.params.speed=w),ve.autoplay.start()})),me.on("slideChange",function(){const ve=me.activeIndex==0?me.slides.length-1:me.activeIndex-1,Pe=me.slides[ve];if(Pe){const Ie=Pe.querySelectorAll(".ecom-animation.ecom-animated");Ie.length&&Ie.forEach(function(qe){qe.classList.remove("ecom-animated","animated"),qe.classList.add("ecom-animated-slider")})}me.el&&me.slides.filter(qe=>qe.classList.contains("ecom-swiper-slide-visible")).forEach(qe=>{let Ge=null;qe&&qe.nodeType===1&&(Ge=qe.querySelectorAll(".ecom-animation.ecom-animated-slider"),Ge&&Ge.length&&Ge.forEach(function(Ze){Ze.classList.add("ecom-animated")}))})})}var Ee;E.isLive&&window.addEventListener("resize",function(){Ee&&clearTimeout(Ee),Ee=setTimeout(()=>{me.update()},200)}),E.isLive?fe():setTimeout(function(){fe()},200)})};let R=C(r);if(!R){let V=0;const K= window.__ectimmers["ecom-3jitw69sg8u"]["peiy9e4w9"] = setInterval(function(){V++;const ce=C(r);ce?(clearInterval(K),T(ce)):V>=20&&clearInterval(K)},200);return}T(R),I.querySelectorAll("img").length&&I.querySelectorAll("img").forEach(function(V,K){s&&V.removeAttribute("loading")})

                    });
                    
                        document.querySelectorAll('.ecom-3jitw69sg8u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3jitw69sg8u', settings: {"items":[{"id":"ecom-yyr1l7y9j3","slider_pagination_image":null},{"id":"ecom-tzg3of5wye","slider_pagination_image":null},{"id":"ecom-0ewuubgcph5d","slider_pagination_image":null},{"id":"ecom-u59nso685ic","slider_pagination_image":null},{"id":"ecom-6dujh0mg8yh","slider_pagination_image":null},{"id":"ecom-fgsmvtsuhpj","slider_pagination_image":null},{"id":"ecom-q4g6ywztr6o","slider_pagination_image":null},{"id":"ecom-oxuiy32ni08","slider_pagination_image":null},{"id":"ecom-ure6s6qnyo","slider_pagination_image":null},{"id":"ecom-n04soghffsf","slider_pagination_image":null}],"contentWidth":"100%","slider_navigation_layout":"disable","slider_prev_icon":"<svg xmlns=\"http: //www.w3.org/2000/svg\" width=\"52\" height=\"52\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-left\"><polyline points=\"15 18 9 12 15 6\"></polyline></svg>","slider_next_icon":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"52\" height=\"52\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-right\"><polyline points=\"9 18 15 12 9 6\"></polyline></svg>","slider_effect":"slide","slider_speed":500,"isCustomHeight":true,"verticalAlign":"flex-start","slider_autoplay":false,"slider_items":3,"slider_loop":false,"slider_autoplay_speed":6000,"slider_items__tablet":3,"slider_spacing__tablet":24,"slider_items__mobile":1.1,"slider_spacing__mobile":0,"slider_spacing_row__mobile":0,"slider_style":"horizontal","paginitionAnimation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k1874mbxrx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k1874mbxrx', settings: {"items":[{"id":"ecom-rficxszp6x8","slider_pagination_image":null},{"id":"ecom-lrke0uzfg9h","slider_pagination_image":null}],"contentWidth":"100%","slider_navigation_layout":"disable","slider_prev_icon":"<svg xmlns=\"http: //www.w3.org/2000/svg\" width=\"52\" height=\"52\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-left\"><polyline points=\"15 18 9 12 15 6\"></polyline></svg>","slider_next_icon":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"52\" height=\"52\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-right\"><polyline points=\"9 18 15 12 9 6\"></polyline></svg>","slider_effect":"slide","slider_speed":500,"isCustomHeight":true,"verticalAlign":"flex-start","slider_autoplay":true,"slider_items":3,"slider_loop":false,"slider_autoplay_speed":6000,"slider_items__tablet":2.2,"slider_spacing__tablet":24,"slider_items__mobile":1.1,"slider_spacing__mobile":0,"slider_spacing_row__mobile":0,"slider_style":"horizontal","slider_group":1},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f1ki8f8vt9g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f1ki8f8vt9g', settings: {"items":[{"id":"ecom-y0swmp7haj","slider_pagination_image":null},{"id":"ecom-g7vn1y4sh0n","slider_pagination_image":null},{"id":"ecom-579k9erxb6d","slider_pagination_image":null},{"id":"ecom-sfiy1gg5rna","slider_pagination_image":null},{"id":"ecom-qgd15qfc4h9","slider_pagination_image":null},{"id":"ecom-ymrcq32b1r","slider_pagination_image":null},{"id":"ecom-vrk9wv7np2","slider_pagination_image":null},{"id":"ecom-gs02xn6lyp","slider_pagination_image":null},{"id":"ecom-8kigzv49sni","slider_pagination_image":null},{"id":"ecom-ibye7lbv01d","slider_pagination_image":null},{"id":"ecom-z6w20bcpgvi","slider_pagination_image":null},{"id":"ecom-l36sgrpqhum","slider_pagination_image":null}],"contentWidth":"100%","slider_navigation_layout":"disable","slider_prev_icon":"<svg xmlns=\"http: //www.w3.org/2000/svg\" width=\"52\" height=\"52\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-left\"><polyline points=\"15 18 9 12 15 6\"></polyline></svg>","slider_next_icon":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"52\" height=\"52\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-right\"><polyline points=\"9 18 15 12 9 6\"></polyline></svg>","slider_effect":"slide","slider_speed":500,"isCustomHeight":true,"verticalAlign":"flex-start","slider_autoplay":true,"slider_items":3,"slider_loop":false,"slider_autoplay_speed":6000,"slider_items__tablet":2.2,"slider_spacing__tablet":24,"slider_items__mobile":1.1,"slider_spacing__mobile":0,"slider_spacing_row__mobile":0,"slider_style":"horizontal","slider_group":1},isLive: true});
                        });
                    

                })();
            
;try{
 function openPopup(key) {
  const popup = document.querySelector(
    '.popup-overlay[data-popup="' + key + '"]'
  );
  if (!popup) return;

  popup.style.display = 'flex';
  document.documentElement.style.overflow = 'hidden';
}

function closePopup(popup) {
  popup.style.display = 'none';
  document.documentElement.style.overflow = '';
}

/* ===== TAP + CLICK SUPPORT (iOS SAFE) ===== */
['click', 'touchstart'].forEach(evt => {
  document.addEventListener(evt, function (e) {
    const trigger = e.target.closest('[data-popup]');
    const overlay = e.target.closest('.popup-overlay');
    const box = e.target.closest('.popup-box');

    /* ---- OPEN ---- */
    if (trigger && !overlay) {
      e.preventDefault();
      const key = trigger.getAttribute('data-popup');
      openPopup(key);
      return;
    }

    /* ---- CLOSE (tap outside) ---- */
    if (overlay && !box) {
      closePopup(overlay);
      return;
    }
  }, { passive: false });
});

} catch(error){console.error(error);}